import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getNews as getNewsApi,
  getNewsStats as getNewsStatsApi,
  addNews as addNewsApi,
  updateNews as updateNewsApi,
  updateNewsStatus as updateNewsStatusApi,
  deleteNews as deleteNewsApi,
  uploadNewsCover as uploadNewsCoverApi,
  getNewsCategories as getNewsCategoriesApi,
  addNewsCategory as addNewsCategoryApi,
  updateNewsCategory as updateNewsCategoryApi,
  deleteNewsCategory as deleteNewsCategoryApi,
} from "../../helpers/realbackend_helper";

// ── News ──────────────────────────────────────────────────────────────────────

export const getNews = createAsyncThunk(
  "news/getNews",
  async (params, { rejectWithValue }) => {
    try {
      return await getNewsApi(params);
    } catch (error) {
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Мэдээ татахад алдаа гарлаа")
      );
    }
  }
);

export const getNewsStats = createAsyncThunk(
  "news/getNewsStats",
  async (_, { rejectWithValue }) => {
    try {
      return await getNewsStatsApi();
    } catch (error) {
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Статистик татахад алдаа гарлаа")
      );
    }
  }
);

export const addNews = createAsyncThunk(
  "news/addNews",
  async (data, { rejectWithValue }) => {
    try {
      const response = await addNewsApi(data);
      toast.success("Мэдээ амжилттай нэмэгдлээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Мэдээ нэмэхэд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Мэдээ нэмэхэд алдаа гарлаа")
      );
    }
  }
);

export const updateNews = createAsyncThunk(
  "news/updateNews",
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateNewsApi(data);
      toast.success("Мэдээг амжилттай засварлалаа", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Засварлахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Засварлахад алдаа гарлаа")
      );
    }
  }
);

export const updateNewsStatus = createAsyncThunk(
  "news/updateNewsStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await updateNewsStatusApi(id, { status });
      toast.success("Төлөв амжилттай өөрчлөгдлөө", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Төлөв өөрчлөхөд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Төлөв өөрчлөхөд алдаа гарлаа")
      );
    }
  }
);

export const deleteNews = createAsyncThunk(
  "news/deleteNews",
  async (id, { rejectWithValue }) => {
    try {
      await deleteNewsApi(id);
      toast.success("Мэдээ устгагдлаа", { autoClose: 3000 });
      return { id };
    } catch (error) {
      toast.error("Устгахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Устгахад алдаа гарлаа")
      );
    }
  }
);

export const uploadNewsCover = createAsyncThunk(
  "news/uploadNewsCover",
  async (formData, { rejectWithValue }) => {
    try {
      return await uploadNewsCoverApi(formData);
    } catch (error) {
      toast.error("Зураг upload хийхэд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Зураг upload хийхэд алдаа гарлаа")
      );
    }
  }
);

// ── Categories ────────────────────────────────────────────────────────────────

export const getNewsCategories = createAsyncThunk(
  "news/getNewsCategories",
  async (_, { rejectWithValue }) => {
    try {
      return await getNewsCategoriesApi();
    } catch (error) {
      const msg = typeof error === "string" ? error : (error.response?.data?.message || error.message || "Категори татахад алдаа гарлаа");
      toast.error(`Категори татахад алдаа: ${msg}`, { autoClose: 3000 });
      return rejectWithValue(msg);
    }
  }
);

export const addNewsCategory = createAsyncThunk(
  "news/addNewsCategory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await addNewsCategoryApi(data);
      toast.success("Категори нэмэгдлээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error(
        typeof error === "string" ? error : (error.response?.data?.message || "Категори нэмэхэд алдаа гарлаа"),
        { autoClose: 3000 }
      );
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Категори нэмэхэд алдаа гарлаа")
      );
    }
  }
);

export const updateNewsCategory = createAsyncThunk(
  "news/updateNewsCategory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateNewsCategoryApi(data);
      toast.success("Категори засварлагдлаа", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Категори засварлахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Категори засварлахад алдаа гарлаа")
      );
    }
  }
);

export const deleteNewsCategory = createAsyncThunk(
  "news/deleteNewsCategory",
  async (id, { rejectWithValue }) => {
    try {
      await deleteNewsCategoryApi(id);
      toast.success("Категори устгагдлаа", { autoClose: 3000 });
      return { id };
    } catch (error) {
      toast.error(
        typeof error === "string" ? error : (error.response?.data?.message || "Категори устгахад алдаа гарлаа!"),
        { autoClose: 3000 }
      );
      return rejectWithValue(
        typeof error === "string" ? error : (error.response?.data?.message || error.message || "Категори устгахад алдаа гарлаа")
      );
    }
  }
);
